export const Delete = ({text, id, disabled, handleClick}) => {
  return (
    <div>
      {
          <button onClick={() => handleClick(id)} id={id} type="button" className="text-sm" disabled={disabled}>
            <div className={disabled ? "font-bold text-grey opacity-60" : "font-bold text-red hover:scale-110 transition duration-300"} >
              {text}
            </div>
          </button>
      }
    </div>
  );
};

export const Edit = ({text, id, disabled, handleClick}) => {
  return (
    <div>
      {
          <button onClick={() => handleClick(id)} id={id} type="button" className="text-sm" disabled={disabled}>
            <div className={disabled ? "font-bold text-grey opacity-60" : "font-bold text-grayP"}>
              {text}
            </div>
          </button>
      }
    </div>
  );
};